import type { LandingLuckyNumber } from '@/lib/landing-auth'

export type LuckyNumberPurchase = {
  key: string
  isWon: boolean
  prizeSource?: 'roulette' | 'scratch_card' | 'purchase_scratch_card' | 'achievement' | null
  purchasedAt: string | null
  amount: string | null
  numbers: LandingLuckyNumber[]
  visibleNumbers: LandingLuckyNumber[]
}

export function groupLuckyNumbersByPurchase(
  numbers: LandingLuckyNumber[],
  query: string
): LuckyNumberPurchase[] {
  const groups = new Map<string, LuckyNumberPurchase>()

  numbers.forEach((number, index) => {
    // A data de atribuição pode ser igual para compras distintas; só o pagamento as identifica.
    const key =
      number.is_won && number.roulette_prize_id != null
        ? `roulette:${number.roulette_prize_id}`
        : number.purchase_id != null
          ? `purchase:${number.purchase_id}`
          : `legacy:${number.formatted_number}:${index}`
    let group = groups.get(key)
    if (!group) {
      group = {
        key,
        isWon: !!number.is_won,
        prizeSource: number.prize_source,
        purchasedAt: number.purchase_at ?? number.assigned_at,
        amount: number.purchase_amount ?? null,
        numbers: [],
        visibleNumbers: [],
      }
      groups.set(key, group)
    }
    group.numbers.push(number)
    if (!query || number.formatted_number.includes(query))
      group.visibleNumbers.push(number)
  })

  return [...groups.values()]
    .filter((group) => group.visibleNumbers.length > 0)
    .sort((a, b) => {
      const aTime = a.purchasedAt ? Date.parse(a.purchasedAt) : 0
      const bTime = b.purchasedAt ? Date.parse(b.purchasedAt) : 0
      return (Number.isNaN(bTime) ? 0 : bTime) - (Number.isNaN(aTime) ? 0 : aTime)
    })
}

export function formatPurchaseAmount(amount: string | null): string {
  if (amount == null || amount.trim() === '') return 'Valor indisponível'
  const value = Number(amount)
  if (!Number.isFinite(value) || value < 0) return 'Valor indisponível'
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(
    value
  )
}
